import * as React from "react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { ActionAnchor } from "@tenforce/toolbox-button-push-react"

interface Props {
    label: string
    url: string
}

interface State {
    hasHover: boolean
}

export default class Workspace extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            hasHover: false,
        }
    }

    render(): JSX.Element {
        const { label, url } = this.props
        const { hasHover } = this.state
        return (
            <li
                onMouseEnter={(): void => this.setHover(true)}
                onMouseLeave={(): void => this.setHover(false)}
            >
                <ActionAnchor
                    extraClasses={`tw-my-1 tw-py-1 tw-px-3 theme-bubble tw-flex tw-items-center ${
                        hasHover ? "bg-cloud" : ""
                    }`}
                    href={url}
                    data-ft-workspace={label.toLowerCase()}
                >
                    <h3>{Symbols.Workspace}</h3>
                    <div>
                        <div className="p">{label}</div>
                    </div>
                </ActionAnchor>
            </li>
        )
    }

    setHover = (hasHover: boolean): void => {
        this.setState({ hasHover })
    }
}
